<template>
	<el-main class="userdetail">
		<div class="mybread">
			<p><i class="el-icon-location"></i>当前位置：</p>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/author' }">账号管理</el-breadcrumb-item>
				<el-breadcrumb-item>账号详情</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="header">
			<div class="header-info">
				<h1>{{ `${form.realname} ${form.en_name}` }}</h1>
				<p style="font-size: 20px; font-weight: 550;">{{ `${form.department.short_name} - ${form.role?.role_name}` }}
				</p>
				<p>{{ `${form.nickname}` }}</p>
			</div>
			<div class="header-status">
				<div class="switch" style="float: right; margin-right: 10px;" v-if="NodeInclude('199')">
					<div class="el-switch" :class="{ 'is-checked': form.status == '1' ? true : false }"
						@click="statusChange()">
						<span class="el-switch__core"></span>
					</div>
				</div>
				<div v-if="NodeInclude('201')">
					<el-button type="primary" round style="text-align: center;"
						@click="showCeaseFn()">项目交接情况</el-button>
				</div>
			</div>
		</div>

		<div class="base1">
			<h3 class="ntitle">基本信息</h3>
			<div class="operater">
				<div class="linkline" @click="toEditFn" v-if="NodeInclude('199')">编辑</div>
			</div>
			<ul>
				<li>
					<p>
						<label>中文名：</label><a>{{ form.realname }}</a>
					</p>
					<p>
						<label>部门：</label><a>{{ form.department.en_name }}</a>
					</p>
					<p>
						<label>员工编号：</label><a>{{ form.user_no }}</a>
					</p>
					<p>
						<label>用户名：</label><a>{{ form.nickname }}</a>
					</p>
					<p>
						<label>性别：</label><a>{{ form.sex == '1' ? '男' : '女' }}</a>
					</p>
					<p>
						<label>入职时间：</label><a>{{ form.hire_date }}</a>
					</p>
				</li>
				<li>
					<p>
						<label>英文名：</label><a>{{ form.en_name }}</a>
					</p>
					<p>
						<label>职位：</label><a>{{ form.role?.role_name }}</a>
					</p>
					<p>
						<label>职级：</label><a>{{ form.position.name }}</a>
					</p>
					<p>
						<label>手机号：</label><a>{{ form.phone }}</a>
					</p>
					<p>
						<label>婚姻状况：</label><a>{{ form.marital_status == '1' ? '未婚' : '已婚' }}</a>
					</p>
					<p>
						<label>是否正式员工：</label><a>{{ form.is_regular_employee == '1' ? '实习' : '正式' }}</a>
					</p>
				</li>
			</ul>
		</div>
		<!-- <div class="base1">
			<h3 class="ntitle">职位权限</h3>
			<ul>
				<li>
					<p>
						<label>职位：</label>
						<a v-if="NodeInclude('202')">
							<el-select v-model="form.level" placeholder="请选择" style="margin-right: 0; width: 400px;"
								@change="updateLevelFn" filterable>
								<el-option :label="`${v.role_name}`" :value="v.id" v-for="(v, i) in roleList"
									:key="`lv_${i}`"></el-option>
							</el-select>
						</a>
						<a v-else>{{ form.role?.role_name }}</a>
					</p>
				</li>
				<li>
				</li>
			</ul>
		</div> -->
		<div class="base1">
			<h3 class="ntitle">查阅范围</h3>
			<!-- <div class="operater">
				<div class="linkline" @click="toRoleFn(2)" v-if="NodeInclude('203')">编辑</div>
			</div> -->
			<ul>
				<li style="width: 1500px;">
					<p>
						<label>项目基本范围：</label>
						<a v-if="NodeInclude('203')">
							<el-radio-group v-model="form.access" @change="updateAccessFn">
								<el-radio label="1">自己/下属</el-radio>
								<el-radio label="2">全部</el-radio>
							</el-radio-group>
						</a>
						<a v-else>{{ form.access == '1' ? '自己/下属' : (form.access == '2' ? '全部' : '暂无') }}</a>
					</p>
					<p>
						<label>协助查阅项目：</label>
						<a v-if="whiteList?.length">
							<div v-for="(item, index) in whiteList" :key="`white_${index}`" class="whitelist">
								<span>{{ item.ncbn_str }}</span>
								<span class="whitelist_del" v-if="NodeInclude('203')">
									<el-button type="danger" size="small" icon="el-icon-delete" circle @click="deleteWhite(item.id, item.type, item.ncbn_str)"></el-button>
								</span>
							</div>
						</a>
						<a v-else>暂无</a>
					</p>
					<p v-if="NodeInclude('203')">
						<label></label>
						<a>
							<el-button type='primary' icon="el-icon-plus" @click="showProject">新增</el-button>
						</a>
					</p>
					<p>
						<label>个人报销事务基本范围：</label>
						<a v-if="NodeInclude('203')">
							<el-radio-group v-model="form.self_access" @change="updateSelfAccessFn">
								<el-radio label="1">自己/下属</el-radio>
								<el-radio label="2">全部</el-radio>
							</el-radio-group>
						</a>
						<a v-else>{{ form.self_access == '1' ? '自己/下属' : (form.self_access == '2' ? '全部' : '暂无') }}</a>
					</p>
					<p>
						<label>个人请假事务基本范围：</label>
						<a v-if="NodeInclude('203')">
							<el-radio-group v-model="form.holiday_access" @change="updateHolidayAccessFn">
								<el-radio label="1">自己/下属</el-radio>
								<el-radio label="2">全部</el-radio>
							</el-radio-group>
						</a>
						<a v-else>{{ form.holiday_access == '1' ? '自己/下属' : (form.holiday_access == '2' ? '全部' : '暂无') }}</a>
					</p>
				</li>
				<li>
				</li>
			</ul>
		</div>
		<div class="base1">
			<h3 class="ntitle">直属上下级</h3>
			<!-- <div class="operater">
				<div class="linkline" @click="toRoleFn(3)" v-if="NodeInclude('204')">编辑</div>
			</div> -->
			<ul>
				<li>
					<p>
						<label>直属领导：</label>
						<a v-if="NodeInclude('204')">
							<el-select v-model="form.leader" placeholder="请选择" style="margin-right: 0; width: 400px;"
								@change="updateLeaderFn" filterable>
								<el-option :label="`${v.realname} ${v.en_name}`" :value="v.id"
									v-for="(v, i) in userList" :key="i"></el-option>
							</el-select>
						</a>
						<a v-else>{{ form.leader_name }} {{ form.leader_en_name }}</a>
					</p>
					<p>
						<label>下属：</label>
					<ul class="authorlist" v-if="form.subordinate?.length">
						<li v-for="(item, index) in form.subordinate" :key="`sub_${index}`">
							<div class="subbtn" @click="toPersonFn(item.id)">
								{{ item.realname }} {{ item.en_name }}
							</div>
						</li>
					</ul>
					<a v-else>暂无</a>
					</p>
				</li>
				<li>
				</li>
			</ul>
		</div>
		<div class="base1">
			<h3 class="ntitle">办公用品</h3>
			<ul>
				<li>
					<p>
						<label></label>
						<a v-if="NodeInclude('205')">
							<el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
								style="margin-right: 0; width: 400px;" placeholder="请输入领取的办公用品，电脑或U盘等，没有可不填"
								v-model="form.office_list" @change="updateOfficeFn">
							</el-input>
						</a>
						<a v-else>{{ form.office_list ? form.office_list : '暂无' }}</a>
					</p>
				</li>
			</ul>
		</div>

		<el-dialog title="异常提醒" :visible.sync="ceaseShow" width="500px">
			<ul class="aul" style="padding:0">
				<li>
					该用户存在未完成的交接，无法停用账号！
				</li>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelCease">取 消</el-button>
				<el-button type="primary" @click="showCeaseFn()">查 看</el-button>
			</span>
		</el-dialog>

		<el-dialog title="项目交接情况" :visible.sync="logShow" width="800px">
			<ul class="aul" style="padding:0" v-if="handoverList?.length">
				<li v-for="(v, i) in handoverList" :key="`han_${i}`">
					{{ v.project_str }}
				</li>
			</ul>
			<ul class="aul" style="padding:0" v-else>
				<li>暂无可交接的项目</li>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="logShow = false">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="新增协助查阅" :visible.sync="projectShow" width="650px">
			<el-form ref="projectForm" :model="projectForm" label-width="150px" label-position="left">
				<el-form-item label="选择客户：">
					<el-col :span="24">
						<el-select v-model="projectForm.client_id" placeholder="" style="margin-right: 0; width: 100%;"
							filterable @change="clientChange">
							<el-option :label="v.company" :value="v.id" v-for="(v, i) in clientList"
								:key="i"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="选择品牌：">
					<el-col :span="24">
						<el-select v-model="projectForm.barnd_list" multiple collapse-tags placeholder=""
							style="margin-right: 0; width: 100%;" filterable @change="brandChange">
							<el-option :label="v.brand" :value="v.id" v-for="(v, i) in brandList" :key="i"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="选择项目：">
					<el-col :span="24">
						<el-select v-model="projectForm.project_list" multiple collapse-tags placeholder=""
							style="margin-right: 0; width: 100%;" filterable @change="projectChange">
							<el-option :label="`${v.contract_no}-${v.contract_name}`" :value="v.id"
								v-for="(v, i) in projectList" :key="i"></el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<!-- <div style="text-align: center;">注：关联项目后不能修改</div> -->
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelProjectId">取 消</el-button>
				<el-button type="primary" @click="confirmProjectId">确 认</el-button>
			</span>
		</el-dialog>

		<el-dialog title="删除协助查阅项目" :visible.sync="deleteShow" width="650px">
			<ul class="aul" style="padding:0">
				<li>
					<span>{{ tempDelete.ncbn_str }}</span>
				</li>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="deleteShow = false">取 消</el-button>
				<el-button type="primary" @click="handleDelete()">确 定</el-button>
			</span>
		</el-dialog>

	</el-main>
</template>

<script>
import * as api from '@/api'
export default {
	name: 'authorView',
	data() {
		return {
			nodeLimtList: [],
			userList: [],
			departList: [],
			positionList: [],
			whiteList: [],//白名单
			roleList: [],
			form: {
				user_no: '',
				nickname: '',
				user_pwd: '',
				en_name: '',
				realname: '',
				phone: '',
				dep_id: '',
				department: {},
				position_id: '',
				position: {},
				leader: '',
				level: '',
				office_list: '',
				subordinate: [],
				leader_en_name: '',
				leader_name: '',
				access: '',
				status: '',
			},
			w: 469,
			h: 676,
			ceaseShow: false,
			handoverList: [],
			logShow: false,
			projectShow: false, //关联弹窗
			projectForm: {
				option: '1',
				user_id: '',
				client_id: '',
				barnd_list: [],
				brand_id: '',
				project_list: [],
				project_id: '',
				del_str: '',
			},
			deleteShow: false, // 删除弹窗
			tempDelete: {},
			clientList: [],
			brandList: [],
			projectList: [],
		}
	},
	computed: {

	},
	created() {
		this.query = this.$route.query
		this.getDetail(this.query.id)
		this.getClientList()
	},
	mounted() {
		this.getUserList()
		this.getRoleList()
	},
	watch: {
		['form.phone'](val) {
			if (val != undefined) {
				this.$nextTick(() => {
					this.form.phone = val.replace(/\D/g, '');
				});
			}
		},
	},
	methods: {
		checkUrlFn() {
			// 获取当前URL的哈希部分  
			const hash = window.location.hash;
			// 移除'#'字符  
			const url = hash.substring(1);
			
			let postData = {
				url_path: url
			}
			api.checkLoginUrl(postData).then((res) => {
				if (res.status == 400) {
					this.$message({
						type: 'info',
						message: '暂无权限',
					})
					this.$router.push({
						path: `/home`
					});
				}
			})
		},
		checkNodeFn(menu_id) {
			let postData = {
				menu_id,
			}
			api.checkNode(postData).then((res) => {
				this.nodeLimtList = res.node_ids.split(',')
			})
		},
		NodeInclude(val) {
			return this.nodeLimtList.includes(val)
		},
		getHandoverList(uid) {
			this.$fly
				.post('apiAccount_getProjectHandoverList.html', {
					user_id: uid
				})
				.then((res) => {
					this.handoverList = res
				})
		},
		async getUserList() {
			this.$fly
				.post('apiAccount_getUserList.html', {
					per_page: 5000,
				})
				.then((res) => {
					this.userList = res.itemList
				})
		},
		async getDepartList() {
			return new Promise((resolve) => {
				this.$fly
					.post('apiAccount_getDepartmentList.html', {

					})
					.then((res) => {
						this.departList = res
						resolve(res)
					})
			})
		},
		async getWhiteList() {
			return new Promise((resolve) => {
				this.$fly
					.post('apiProject_getWhitelist.html', {
						user_id: this.form.uid,
					})
					.then((res) => {
						this.whiteList = res?.white_project
						resolve(res)
					})
			})
		},
		async getRoleList() {
			return new Promise((resolve) => {
				this.$fly
					.post('ApiRole_getRoleList.html', {
						per_page: 5000,
					})
					.then((res) => {
						this.roleList = res.filter((item) => { return item.role_name != '超管' })
						resolve(res)
					})
			})
		},
		async getDetail(id) {
			this.checkUrlFn()
			this.checkNodeFn('61')
			api.getAccountDetail({
				uid: id,
			})
				.then((res) => {
					const {
						nickname,
						// user_pwd,
						realname,
						en_name,
						user_no,
						phone,
						role,
						dep_id,
						department,
						position_id,
						position,
						subordinate,
						leader,
						leader_en_name,
						leader_name,
						access,
						self_access,
						holiday_access,
						office_list,
						level,
						status,
            sex,
            hire_date,
            is_regular_employee,
            marital_status,
					} = res.bkUserArr
					this.form = {
						uid: id || '',
						nickname,
						user_pwd: '',
						realname,
						en_name,
						user_no,
						phone,
						role,
						dep_id,
						department,
						position_id,
						position,
						subordinate,
						leader,
						leader_en_name,
						leader_name,
						access,
						self_access,
						holiday_access,
						office_list,
						level,
						status,
						sex,
            hire_date,
            is_regular_employee,
            marital_status,
					}
					this.query.id ? this.form.user_pwd = '****' : this.form.user_pwd = ''
					this.getDepartList().then(() => {
						this.$fly
							.post('apiAccount_getPositionList.html', {
								department_id: dep_id
							})
							.then((res) => {
								this.positionList = res
							})
					})
					this.getWhiteList()
					this.getHandoverList(this.form.uid)
					return res
				})
		},
		addUpdateUser() {
			this.form.option = this.form.uid ? '2' : '1'
			if (this.form.option == '2' && this.form.user_pwd == '****') {
				this.form.user_pwd = ''
			} else if (this.form.option == '1' && this.form.user_pwd == '') {
				this.form.user_pwd = '123456'
			}
			const tempForm = JSON.parse(JSON.stringify(this.form))
			delete tempForm.department
			delete tempForm.position
			api.addUpdateUser({
				...tempForm,
				dep_id: this.form.dep_id,
				position_id: this.form.position_id,
			}).then(() => {
				this.$message.success('success')
				this.$router.go(-1)
			})
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.$router.go(-1)
		},
		toEditFn() {
			this.query.id ? this.$router.push({ path: '/author/detail?id=' + this.query.id }) : false
		},
		toRoleFn(n) {
			this.query.id ? this.$router.push({
				path: '/author/build',
				query: { id: this.query.id, type: n },
			}) : false
		},
		toPersonFn(id) {
			this.$router.push({
				path: '/author/view',
				query: { id: id },
			})
		},
		statusChange() {//status 1是启用 2是停用
			const handoverList = this.handoverList
			if (this.form.status == '1') {
				if (handoverList?.length) {
					this.ceaseShow = true
					return false
				}
				else {
					//停用
					this.form.status = '2'
					api.addUpdateUser({
						option: '2',
						uid: this.form.uid,
						nickname: this.form.nickname,
						phone: this.form.phone,
						status: '2',
					}).then(() => {
						this.$message.success('success')
					})
				}
			}
			else {
				//启用
				this.form.status = '1'
				api.addUpdateUser({
					option: '2',
					uid: this.form.uid,
					nickname: this.form.nickname,
					phone: this.form.phone,
					status: '1',
				}).then(() => {
					this.$message.success('success')
				})
			}
		},
		cancelCease() {
			this.ceaseShow = false
		},
		showCeaseFn() {
			this.ceaseShow = false
			this.logShow = true
		},
		showProject() {
			this.projectForm = {
				option: '1',
				user_id: this.form.uid,
				client_id: '',
				// barnd_list: [],
				brand_id: '',
				// project_list: [],
				project_id: '',
				del_str: '',
			},
				this.projectShow = true
		},
		getClientList(client_id, brand) {
			this.$fly.post('apiSale_getClientBrandList.html', {
				client_id,
				brand,
			}).then((res) => {
				if (!client_id && !brand) {
					this.clientList = res
				}
				else if (client_id && !brand) {
					this.brandList = res.length ? res : false
				}
				else if (client_id && brand) {
					this.projectList = res.length ? res : false
					console.log(this.projectList);
				}
			})
		},
		clientChange(v) {
			this.projectForm.client_id = v
			this.getClientList(v)
			//清空品牌列表和所选品牌
			this.brandList = []
			this.projectForm.barnd_list = []
			this.projectForm.brand_id = ''
			//清空项目列表和所选项目
			this.projectList = []
			this.projectForm.project_list = []
			this.projectForm.project_id = ''
			this.$forceUpdate()
		},
		brandChange(v) {
			const client_id = this.projectForm.client_id
			const brand = v.toString()
			this.projectForm.brand_id = brand
			this.getClientList(client_id, brand)
			//清空项目列表和所选项目
			this.projectList = []
			this.projectForm.project_list = []
			this.projectForm.project_id = ''
			this.$forceUpdate()
		},
		projectChange(v) {
			const project = v.toString()
			this.projectForm.project_id = project
			this.$forceUpdate()
		},
		cancelProjectId() {
			this.projectShow = false
		},
		confirmProjectId() {
			const tempForm = JSON.parse(JSON.stringify(this.projectForm))
			delete tempForm.barnd_list
			delete tempForm.project_list
			if (tempForm.project_id) {
				delete tempForm.brand_id
				delete tempForm.client_id
			}
			else if (tempForm.brand_id) {
				delete tempForm.client_id
			}
			this.$fly.post('apiProject_addOrUpdateWhitelist.html', {
				...tempForm,
			}).then((res) => {
				if (res.status == 200) {
					//确认完毕关闭弹窗清空临时form
					this.projectShow = false
					this.getDetail(this.query.id)
				}
				else {
					this.$message.error(res.message)
				}
			})
		},
		deleteWhite(id, type, str) {
			this.tempDelete = {
				user_id: this.form.uid,
				del_str: id,
				type,
				ncbn_str: str,
			}
			this.deleteShow = true
		},
		handleDelete() {
			this.$fly.post('apiProject_delWhitelist.html', {
				...this.tempDelete
			}).then((res) => {
				if (res.status == 200) {
					this.deleteShow = false
					this.getDetail(this.query.id)
				}
				else {
					this.$message.error(res.message)
				}
			})
		},
		updateLevelFn() {
			api.addUpdateUser({
				option: 2,
				uid: this.form.uid,
				nickname: this.form.nickname,
				phone: this.form.phone,
				//以上必传
				level: this.form.level,
			}).then(() => {
				this.$message.success('success')
			})
		},
		updateAccessFn() {
			api.addUpdateUser({
				option: 2,
				uid: this.form.uid,
				nickname: this.form.nickname,
				phone: this.form.phone,
				//以上必传
				access: this.form.access,
			}).then(() => {
				this.$message.success('success')
			})
		},
		updateSelfAccessFn() {
			api.addUpdateUser({
				option: 2,
				uid: this.form.uid,
				nickname: this.form.nickname,
				phone: this.form.phone,
				//以上必传
				self_access: this.form.self_access,
			}).then(() => {
				this.$message.success('success')
			})
		},
		updateHolidayAccessFn() {
			api.addUpdateUser({
				option: 2,
				uid: this.form.uid,
				nickname: this.form.nickname,
				phone: this.form.phone,
				//以上必传
				holiday_access: this.form.holiday_access,
			}).then(() => {
				this.$message.success('success')
			})
		},
		updateLeaderFn() {
			api.addUpdateUser({
				option: 2,
				uid: this.form.uid,
				nickname: this.form.nickname,
				phone: this.form.phone,
				//以上必传
				leader: this.form.leader,
			}).then(() => {
				this.$message.success('success')
			})
		},
		updateOfficeFn() {
			api.addUpdateUser({
				option: 2,
				uid: this.form.uid,
				nickname: this.form.nickname,
				phone: this.form.phone,
				//以上必传
				office_list: this.form.office_list,
			}).then(() => {
				this.$message.success('success')
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.header {
	//标题样式
	@extend %box;
	box-sizing: border-box;
	width: 100%;
	background: #fff;
	padding: 20px 40px;
	margin-bottom: 10px;
	@extend %center;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: flex-start;

	.header-info {
		width: 80%;
		@extend %center;
		align-items: flex-start;
		text-align: left;

		h1 {
			font: 700 28px/1 $font;
			margin-bottom: 16px;
		}

		p {
			font: 16px/2 $font;
		}
	}

	.header-status {
		@extend %center;
		flex-flow: row nowrap;

		.button {
			box-sizing: border-box;
			min-width: 100px;
			border-radius: 20px;
			padding: 10px 15px;
			font: 12px/1 $font;
			color: #fff;
		}
	}
}

.userdetail {
	.history {
		@extend %box;
		padding: 30px 40px;
	}

	.base1 {
		@extend %box;
		margin-bottom: 20px;
		padding: 30px 40px;
		position: relative;

		>ul {
			@extend %start;
			color: #231f20;
			background: #f2f2f2;
			padding: 0 25px;
			border-radius: 20px;
			margin-bottom: 20px;
			position: relative;

			&:last-of-type {
				margin-bottom: 0;
			}

			li {
				width: 50%;
				font: 14px/3 $font;

				p {
					min-height: 42px;
					padding: 5px 0;
					@extend %start;

					label {
						width: 150px;
						white-space: nowrap;
						flex: none;
					}


				}
			}
		}
	}

	.authorlist {
		width: 100%;
		padding: 5px 0 0;
		flex-flow: column nowrap;

		li {
			width: auto;
			position: relative;
			margin-bottom: 15px;

			&:last-of-type {
				margin-bottom: 32px;
			}

			.subbtn {
				display: inline-block;
				padding: 0 5px;
				height: 32px;
				line-height: 32px;
				border-bottom: 1px solid transparent;
				text-align: center;
				cursor: pointer;

				&:hover {
					border-bottom: 1px solid #333;
				}
			}

		}
	}
}

.switch {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
}

.el-switch {

	font: 12px/30px $font;

	&.cursor {
		cursor: not-allowed;

		.el-switch__core {
			background-color: #999888;
			border-color: #999888;
			cursor: not-allowed;
		}
	}

	&.is-checked {

		.el-switch__core {
			background-color: #0E0F22;
			border-color: #0E0F22;

			&::before {
				font: 12px/20px $font;
				content: '启用';
			}
		}
	}

	.el-switch__core {
		width: 60px;
		height: 30px;
		border-radius: 16px;
		background-color: #999888;
		border-color: #999888;
		position: relative;

		&::before {
			font: 12px/20px $font;
			content: '停用';
		}

		&::after {
			content: '';
			display: block;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
		}
	}
}

.operater {
	@extend %start;
	position: absolute;
	top: 30px;
	right: 40px;
	font: 14px/1 $font;
	text-align: center;

	>div {
		min-width: 32px;
		border: 1px solid #DCDFE6;
		border-radius: 3px;
		padding: 9px 10px;
		cursor: pointer;

		&.linkline {
			border-color: transparent;
			background: transparent;
			color: #231f20;

			&:hover {
				&::after {
					display: block;
					content: '';
					height: 0.1px;
					background: #231f20;
				}
			}
		}

		&.linkbox {
			border-color: #0E0F22;
			background: #0E0F22;
			color: #fff;

			&.grey {
				border-color: #c0c4cc;
				background: #c0c4cc;
				color: #fff !important;

				&:hover {
					background: #c0c4cc;
				}
			}

			&:hover {
				background: rgba($color: #0E0F22, $alpha: 0.8);
			}
		}
	}
}

.whitelist {
	.whitelist_del {
		margin-left: 5px;
		opacity: 0;
	}
	&:hover {
		.whitelist_del {
			opacity: 1;
		}
	}
}
</style>